import { render, staticRenderFns } from "./CodeDetail.vue?vue&type=template&id=16de0b2a&scoped=true&"
import script from "./CodeDetail.vue?vue&type=script&lang=ts&"
export * from "./CodeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de0b2a",
  null
  
)

export default component.exports